import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PublicBlogPost } from '../../project-data';

@Component({
  selector: 'app-insights-page',
  templateUrl: './insights-page.component.html',
})
export class InsightsPageComponent {
  @Input({ required: true }) blogPosts: PublicBlogPost[] = [];
  @Input({ required: true }) blogLoading = false;
  @Input({ required: true }) blogError = false;
  @Output() readonly blogPostSelected = new EventEmitter<PublicBlogPost>();

  protected searchQuery = '';
  protected selectedCategory = 'all';
  protected selectedYear = 'all';

  protected categories(): string[] {
    return [...new Set(this.blogPosts.map((post) => post.category).filter(Boolean))].sort();
  }

  protected years(): string[] {
    return [
      ...new Set(
        this.blogPosts
          .map((post) => (post.published_at ? new Date(post.published_at).getFullYear().toString() : ''))
          .filter(Boolean),
      ),
    ].sort((first, second) => Number(second) - Number(first));
  }

  protected filteredPosts(): PublicBlogPost[] {
    const query = this.searchQuery.trim().toLowerCase();

    return this.blogPosts.filter((post) => {
      const matchesQuery =
        !query ||
        post.title.toLowerCase().includes(query) ||
        post.excerpt.toLowerCase().includes(query) ||
        post.category.toLowerCase().includes(query);
      const matchesCategory = this.selectedCategory === 'all' || post.category === this.selectedCategory;
      const year = post.published_at ? new Date(post.published_at).getFullYear().toString() : '';
      const matchesYear = this.selectedYear === 'all' || year === this.selectedYear;

      return matchesQuery && matchesCategory && matchesYear;
    });
  }

  protected updateSearch(event: Event): void {
    this.searchQuery = (event.target as HTMLInputElement).value;
  }

  protected updateCategory(event: Event): void {
    this.selectedCategory = (event.target as HTMLSelectElement).value;
  }

  protected updateYear(event: Event): void {
    this.selectedYear = (event.target as HTMLSelectElement).value;
  }

  protected postDateLabel(post: PublicBlogPost): string {
    const dateValue = post.published_at;
    if (!dateValue) {
      return 'Unscheduled';
    }

    return new Intl.DateTimeFormat('en', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(dateValue));
  }

  protected postMeta(post: PublicBlogPost): string {
    const date = this.postDateLabel(post);
    return post.category ? `${date} / ${post.category}` : date;
  }
}
